import {Directive, ElementRef, HostListener, Renderer} from '@angular/core';

@Directive({
    selector: '[ccCardHover]'
})
export class CardHoverDirective {

    constructor(private el: ElementRef,
                private renderer: Renderer) {
    }

    @HostListener('mouseover') onMouseOver() {
        let part = this.el.nativeElement.querySelector('.icon-accion');
        this.renderer.setElementStyle(part, 'display', 'block');
    }

    @HostListener('mouseout') onMouseOut() {
        let part = this.el.nativeElement.querySelector('.icon-accion');
        this.renderer.setElementStyle(part, 'display', 'none');
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/roles/recursos/directive/card-hover.directive.ts